import { Component } from 'vue-property-decorator';
import AbstractView from '../abstract-view';


@Component
export default class DashboardView extends AbstractView
{

}